import { render, staticRenderFns } from "./AnicomShowTable.vue?vue&type=template&id=04f2a3f8&scoped=true&"
import script from "./AnicomShowTable.vue?vue&type=script&lang=js&"
export * from "./AnicomShowTable.vue?vue&type=script&lang=js&"
import style0 from "./AnicomShowTable.vue?vue&type=style&index=0&id=04f2a3f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f2a3f8",
  null
  
)

export default component.exports